// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=26695cb5-2215-4bbf-b20b-2d4e537f07a0";
};